module.exports = __webpack_public_path__ + "img/long-path.b4cae0c5.png";